import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { HudStatBar } from "../generic/hud-stat-bar/HudStatBar";
import { IdIcon } from "../generic/icon/IdIcon";
import { NumberFormat } from "../generic/number-format/NumberFormat";
import { TypeNumberFormat } from "../generic/number-format/TypeNumberFormat";
export var ProductionCost = function (_a) {
    var productionCost = _a.productionCost;
    return (React.createElement(HudStatBar, { icon: IdIcon.ProductionCostIcn, styleId: IdStyles.IconMedium, backgroundSize: "small", backgroundClassName: IdStyles.HudStat, className: "hud-stat-bar" },
        React.createElement(NumberFormat, { className: IdStyles.TextBoldSecondaryOutline, amount: productionCost, format: TypeNumberFormat.SignedPercent })));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/happiness/ProductionCost.tsx
// module id = 2306
// module chunks = 3